import React from "react";
import styles from "./EditButton.module.css";
import EditIcon from "../icons/EditIcon";
import ArrowLeft from "../icons/ArrowLeft";

interface EditButtonProps {
  open: boolean;
  onClick: () => void;
  style?: React.CSSProperties;
  className?: string;
}

const EditButton: React.FC<EditButtonProps> = ({
  open,
  onClick,
  style,
  className,
}) => {
  return (
    <div onClick={onClick} className={styles.editButton}>
      <div
        style={{
          transform: open ? "rotate(-90deg)" : "rotate(0deg)",
          transition: "transform 0.2s",
          position: "relative",
          left: open ? "1px" : "0px",
        }}
      >
        <div className={styles.arrowLeftIcon}>
          <ArrowLeft />
        </div>
      </div>
    </div>
  );
};

export default EditButton;
